(() => {
  const defineElement = () => {
    if (!customElements.get("ff-collapsable")) {
      class FFCollapsable extends HTMLElement {
        constructor() {
          super();

          this.container = this.querySelector("[data-ff-container]");
          this.headers = this.querySelectorAll("[data-ff-header]");
          this.content = this.querySelector("[data-ff-content]");
          this.contentHeight = this.content.getBoundingClientRect().height;
          this.isOpened = false;
  
          this.alwaysCheckContentHeight =
            this.dataset.ffAlwaysCheckContentHeight || false;

          if (!this.container || !this.content || this.headers.length < 1) {
            return;
          }

          if (!this.alwaysCheckContentHeight && !this.contentHeight) {
            return;
          }

          this.init();
        }

        init() {
          this.container.style.transition = `height ${this.dataset.ffAnimationSeconds}s ease-in-out`;

          this.close();
          this.headers.forEach((header) =>
            header.addEventListener("click", this.toggle.bind(this))
          );

          if (Shopify.designMode && this.id == e.target.id) {
            this.headers[0].click();
          }
        }

        toggle() {
          if (this.isOpened) {
            this.close();
          } else {
            this.open();
          }
        }

        open() {
          this.isOpened = true;
          this.content = this.querySelector("[data-ff-content]");
          this.contentHeight = this.content.getBoundingClientRect().height;
          if (this.alwaysCheckContentHeight) {
            setTimeout(() => {
              this.contentHeight = this.content.offsetHeight;
              this.container.style.height = `${this.contentHeight}px`;
              this.container.style.maxHeight = `${this.contentHeight}px`;
            }, this.dataset.ffAnimationSeconds);
          } else {
            this.container.style.height = `${this.contentHeight}px`;
            this.container.style.maxHeight = `${this.contentHeight}px`;
          }
        }

        close() {
          this.isOpened = false;
          this.container.style.height = "0px";
        }
      }

      customElements.define("ff-collapsable", FFCollapsable);
    }
  };

  const defineElementDesignMode = (e) => {
    defineElement();

    if (e.target.tagName.toLowerCase() == "ff-collapsable") {
      e.target.querySelector("[data-ff-header]").click();
    }
  };

  if (Shopify.designMode) {
    document.removeEventListener(
      "shopify:block:select",
      defineElementDesignMode
    );
    document.addEventListener("shopify:block:select", defineElementDesignMode);
  } else {
    defineElement();
  }
})();
